import React, { useState } from "react";
import styled from "styled-components";
import LightBox from "../Lightbox/Lightbox";
import { v4 as uuidv4 } from "uuid";

const ImagePrev = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

const ImageBox = styled.div`
  position: relative;
  overflow: hidden;
  width: 86px;
  height: 86px;
  max-width: calc(33% - 20px);
  margin: 20px 20px 0 0;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Thumbnails = ({ images, customSizeStyle }) => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <Row>
      {images.map((image) => (
        <ImageBox style={customSizeStyle} key={uuidv4()}>
          <ImagePrev
            src={image.image}
            onClick={() => setActiveImage(image.image)}
          />
        </ImageBox>
      ))}
      <LightBox activeImage={activeImage} setActiveImage={setActiveImage} />
    </Row>
  );
};

export default Thumbnails;
